import * as React from "react"
import * as ReactDom from "react-dom"
import Solution from "../components/views/Solution";
import { requestPageData } from "../services/api";
import { checkLang, setCurrentPage } from "../services/general";

export const page = async () => {
	const solutionContainer = document.getElementById('solutions')
	const SOLUTIONINFO = window.drupalSettings.react.nodo || await requestPageData({ content: "solution", nid: solutionContainer.dataset.nid, langcode: checkLang() })
	ReactDom.render(<Solution data={SOLUTIONINFO} />, solutionContainer)
	setCurrentPage('')
}